import type { JSX } from 'react';

/** Proof OK / Proof fails / Can't tell button, shared by the Proof review queue and the invite sheet. */
export function VerdictButton({
  onClick,
  disabled,
  icon,
  label,
  hint,
  tone,
}: {
  onClick: () => void;
  disabled: boolean;
  icon: JSX.Element;
  label: string;
  /** Keyboard shortcut shown on the button, where one exists. */
  hint?: string;
  tone: 'approve' | 'reject' | 'unclear';
}): JSX.Element {
  const tones = {
    approve: 'border-emerald-500/40 bg-emerald-500/10 text-emerald-600 hover:bg-emerald-500/20',
    reject: 'border-destructive/40 bg-destructive/10 text-destructive hover:bg-destructive/20',
    unclear: 'border-border bg-muted/40 text-muted-foreground hover:bg-muted',
  } as const;
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-keyshortcuts={hint}
      className={`flex flex-col items-center gap-1 rounded-md border px-2 py-2.5 text-xs font-medium transition-colors disabled:opacity-50 ${tones[tone]}`}
    >
      {icon}
      <span>{label}</span>
      {hint && <kbd className="rounded bg-background/60 px-1 text-[10px] font-mono">{hint}</kbd>}
    </button>
  );
}
